var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div-editable",attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.innerText)},on:{"input":_vm.changeText,"focus":function($event){_vm.isChange = false},"blur":_vm.blurFunc}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38604f77","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DivEditable.vue
// module id = null
// module chunks = 